import {Component, OnInit} from "@angular/core";
import {AuthService} from "../../services/auth.service";
import {ApiService} from "../../services/api.service";
import {ActivatedRoute, Router} from "@angular/router";
import {ResetPasswordService} from "../reset-password/services/reset-password.service";
import {Title} from "@angular/platform-browser";

@Component({
  selector: 'app-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
  standalone: false
})
export class HomePageComponent implements OnInit {

  constructor(private authService: AuthService, private apiService: ApiService,
              private router: Router, private route: ActivatedRoute,
              private resetPasswordService: ResetPasswordService,
              private titleService: Title) {
    this.titleService.setTitle("Scalanthropy")
  }
  ngOnInit(): void {
  }

  onSignIn() {
    this.router.navigateByUrl('/app/login');
  }
  onSignUp() {
    this.router.navigateByUrl('/app/users/register');
  }
}
